import SegmentForm from './SegmentForm'
export default SegmentForm
